import { SignUpFormGoal } from "@redotech/redo-marketing-common/signup-form/signup-form";
import { signupFormSchema } from "@redotech/redo-marketing-common/signup-form/signup-form-schema";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getFormsByGoal = {
  name: "getFormsByGoal" as const,
  input: z.object({ goal: createEnum(SignUpFormGoal) }),
  output: z.array(
    z.object({
      id: z.string(),
      form: signupFormSchema,
      publishedAt: z.date().nullable(),
    }),
  ),
};
